import { ALL_TENANTS_KEY, STATUS } from './constants'

export function apiRuleStatusToUi(status) {
  if (status === 'disabled') return STATUS.DISABLED
  if (status === 'draft') return STATUS.DRAFT
  return STATUS.ACTIVE
}

export function uiRuleStatusToApi(status) {
  if (status === STATUS.DISABLED) return 'disabled'
  if (status === STATUS.DRAFT) return 'draft'
  return 'enabled'
}

export function apiRuleToUi(rule = {}) {
  const eventTypeFilters = rule.eventTypeFilters || {}
  return {
    id: rule.id,
    name: rule.name,
    status: apiRuleStatusToUi(rule.status),
    eventTypes: Object.keys(eventTypeFilters),
    endpointIds: rule.destinationIds || [],
    eventTypeFilters,
    linkedCompanyIds: rule.isAllCompanies ? [ALL_TENANTS_KEY] : rule.companyIds || [],
    subscribesToAllEventTypes: Boolean(rule.subscribesToAllEventTypes),
  }
}

export function uiRuleToWritePayload(rule = {}) {
  return {
    name: rule.name,
    status: uiRuleStatusToApi(rule.status),
    subscribesToAllEventTypes: Boolean(rule.subscribesToAllEventTypes),
    eventTypeFilters: rule.eventTypeFilters || {},
    destinationIds: rule.endpointIds || [],
  }
}
